export default "__VITE_ASSET__BljgFh4g__"